import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const LockOpenedAltIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M15.7598 9.98016H14V7.38016C14 5.32016 15.68 3.66016 17.76 3.66016C19.84 3.66016 21.52 5.32016 21.52 7.38016V9.98016H19.76V7.46016C19.76 6.30016 18.98 5.30016 17.76 5.30016C16.54 5.30016 15.76 6.30016 15.76 7.46016L15.7598 9.98016ZM6.56006 9.98047V20.2605H17.4401V9.98047H15.7601H14L12.0001 9.98066L10.0001 9.98047H8.24006H6.56006ZM15.6801 11.7205V18.5005H8.32006V11.7205H15.6801Z"
      />
    </SvgIcon>
  );
});
